/* @flow */
import * as React from 'react';
import { capitalize } from 'lodash';
import EventTracking from 'lib/EventTracking';
import Icon from 'components/Icon';
import Heading from 'components/Heading';
import Link from 'components/Link';
import Table from 'components/Table';
import TooltipTrigger from 'components/TooltipTrigger';
import Tooltip from 'components/Tooltip';
import Text from 'components/Text';

import type { IssueSummary } from 'admin/components/AdminSchoolSisDashboard';
import './styles/AdminSchoolSisDashboardIssueTable.scss';

type Props = {
  type: string,
  subtext: React.Node,
  issues: Array<IssueSummary>,
  orgUuid: string,
};

const AdminSchoolSisDashboardIssueTable = (props: Props) => {
  const { type, subtext, issues, orgUuid } = props;
  const title = `${type}s`;
  const handleLinkClicked = () => {
    EventTracking.track('rostering.errors.downloaded.individual', {
      organization_uuid: orgUuid,
    });
  };

  const entityName = affectedType => {
    if (affectedType === 'group') {
      return 'Class';
    }
    return capitalize(affectedType);
  };

  return (
    <section className="AdminSchoolSisDashboardIssueTable">
      <div className="AdminSchoolSisDashboardIssueTable-header">
        <Heading level="2" levelStyle="3">
          {title}
        </Heading>
        {subtext}
      </div>
      <Table
        head={
          <tr>
            <th>Count</th>
            <th>Entity</th>
            <th>{type}</th>
            <th>CSV</th>
          </tr>
        }>
        <tbody>
          {issues.map(i => {
            return (
              <tr key={i.downloadUrl}>
                {/* Count */}
                <td>{i.affectedCount}</td>
                {/* Entity */}
                <td>{entityName(i.affectedType)}</td>
                {/* Type */}
                <td>
                  <TooltipTrigger placement="top" tooltip={<Tooltip>{i.resolution}</Tooltip>}>
                    <Text
                      className="AdminSchoolSisDashboardIssueTable-description"
                      decoration="dashes">
                      {i.description}
                    </Text>
                  </TooltipTrigger>
                </td>
                {/* CSV Url */}
                <td>
                  <Link
                    href={i.downloadUrl}
                    target="_blank"
                    tooltip="Download CSV"
                    tooltipPlacement="left"
                    onClick={handleLinkClicked}>
                    <Icon name="arrow-down-bar" solo />
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </section>
  );
};

export default AdminSchoolSisDashboardIssueTable;
